module.exports = __webpack_public_path__ + "static/media/aw.1eb0d2cd.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/aw.svg
// module id = 774
// module chunks = 0